import React from "react";
import { Center } from "../Center";
import { AppIcon } from "../Generic/AppIcon";
import AppSlideFadeIn from "../Generic/AppSlideFadeIn";
import Flex from "../Generic/Flex";
import { IsDefined } from "../Generic/IsDefined";

interface Props {
  icon?: JSX.Element;
  label: string;
  linkText?: string;
  onClickLink?: () => void;
}

const EmptyScaffoldBody = (props: Props) => {
  return (
    <Center className="EmptyScaffoldBody">
      <AppSlideFadeIn>
        <Flex direction="column" alignItems="center" justifyContent="center">
          <IsDefined value={props.icon}>{(icon) => <AppIcon icon={icon} size={64} />}</IsDefined>

          <h2>{props.label}</h2>

          <IsDefined value={props.linkText}>
            {(linkText) => (
              <span className="__link" onClick={props.onClickLink}>
                {linkText}
              </span>
            )}
          </IsDefined>
        </Flex>
      </AppSlideFadeIn>
    </Center>
  );
};

export default EmptyScaffoldBody;
